import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { ButtonIcon, ButtonWrapper } from "@insite/mobius/Button";
import { clearBtnStyle } from "@waytek/Utilities/styleguide/btnIcon";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

filterStyles.container = {
    ...filterStyles.container,

    gap: 20,
};

filterStyles.heading = {
    ...filterStyles.heading,

    size: 18,
    weight: 500,
    lineHeight: 1.33,

    css: css`
        text-transform: none;
    `,
};

filterStyles.appliedFilterTag = {
    ...filterStyles.appliedFilterTag,

    mergeCss: true,

    css: css`
        align-items: center;
        font-size: 14px;

        ${ButtonWrapper} {
            ${clearBtnStyle}

            min-height: auto;

            &:not(:disabled):hover {
                background: none;
                color: ${colorPalette.common.global.white};

                ${ButtonIcon} {
                    color: ${colorPalette.common.global.white};
                }
            }
        }
    `,
};

filterStyles.fromGridItem = {
    ...filterStyles.fromGridItem,

    css: css`
        & > div {
            width: 100%;
        }
    `,
};

filterStyles.toGridItem = {
    ...filterStyles.toGridItem,

    css: css`
        & > div {
            width: 100%;
        }
    `,
};

filterStyles.clearFiltersButton = {
    ...filterStyles.clearFiltersButton,

    css: css`
        margin: 0;
    `,
};
